import { useEffect } from 'react'
import Layout from '../components/Layout'
import MainGrid from '../components/MainGrid'
import ContactButtons from '../components/ContactButtons'

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Layout>
      <section className='max-w-2xl'>
        <h1 className='text-2xl lg:text-3xl font-bold'>
          Full-stack developer with a QA background.
        </h1>
        <p className='mt-4 text-sm text-gray-600 leading-relaxed'>
          I build web apps from the front end to the database: React and
          Next.js, server-side validation, PostgreSQL with row-level security,
          and Stripe billing. I started my career in software QA, and I still
          think about how a feature can break while I build it. I'm ISTQB
          certified, completed Harvard's CS50 on edX, and work in English and
          Korean.
        </p>
        <ContactButtons className='mt-6' />
      </section>
      <MainGrid />
    </Layout>
  )
}

export default Home
